import React from 'react';
import './FeaturesBenefits.css';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate= useNavigate();
    return (
        <div className='features-benefits'>

<div
  className="head"
  style={{
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    backgroundColor: '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', // Aligns Back and Next Page buttons to opposite sides
    padding: '10px 20px',
  }}
>
  {/* Back Button */}
  <button
    className="back-button"
    style={{
      backgroundColor: 'transparent',
      border: 'none',
      color: '#fff',
      cursor: 'pointer',
      // fontSize: '1.2rem',
    }}
    onClick={() => navigate('/')}
  >
    &#x227A; Back
  </button>

  {/* Next Page Button */}
  <button
    className="next-button"
    style={{
      backgroundColor: 'transparent',
      border: 'none',
      color: '#fff',
      cursor: 'pointer',
      // fontSize: '1.2rem',
    }}
    onClick={() => navigate('/featuresecond')}
  >
    Next Page &#x227B;
  </button>
</div>

           
           

            <div >
            <div className="poster-section-0">
                <div className="poster-content">
                  <h1 className="poster-title-0">CommentInsight for</h1>
                  {/* <p className="poster-subtitle-0">
                    When you stop listening to your viewers
                  </p>
                  <image></image> */}
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>

             <div className="poster-section-44">
                <div className="poster-content-44">
                  <h1 className="poster-title"></h1>
                  <p className="poster-subtitle-44">
                      To inspire creators to connect deeper with their audience by providing intelligent, real time feedback for more impactful and engaging content
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>
                
             </div>


            <div className='column-1'>
            <div className="poster-section-1">
                <div className="poster-content-1">
                  <h1 className="poster-title">Unexpectable Growth Decline</h1>
                  <p className="poster-subtitle">
                    When you stop listening to your viewers
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>

             <div className="poster-section-2">
                <div className="poster-content-2">
                  <h1 className="poster-title">Massive Engagement Decline</h1>
                  <p className="poster-subtitle">
                    Views,Likes, Comments, Subscribers keeps on declining when you stop listening to your viewers
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>

             </div>
            </div>
             <div className="poster-section-3">
                <div className="poster-content">
                  <h1 className="poster-title"></h1>
                  <p className="poster-subtitle">
                   We helps you to listen to your viewers continuous changing demands, <br></br>which helps you to create more engaging data-driven videos
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>
                
             </div>

             <div className="poster-section-4">
                <div className="poster-content">
                  <h1 className="poster-title"></h1>
                  <p className="poster-subtitle">
                   Viewers love creators who listens to their feedbacks and implements them
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>
                
             </div>

             <div className="poster-section-5">
                <div className="poster-content">
                  <h1 className="poster-title">It's a powerful tool</h1>
                  <p className="poster-subtitle">
                   That helps you to listen to your viewers demands
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>
                
             </div>

          

             <div >

             <div className="poster-section">
                <div className="poster-content">
                  <h1 className="poster-title">Get <i className='poster-title'>Actionable</i> Feedbacks</h1>
                  <p className="poster-subtitle">
                   Valuable feedbacks directly from your viewers
                  </p>
                  {/* <button className="poster-button">Learn More</button> */}
                </div>
                
             </div>

             <div className="poster-section-7">
                <div className="poster-content">
                  <h1 className="poster-title">Understand your <i className='poster-title'>Competition</i></h1>
                  <p className="poster-subtitle">
                   We didn't stop there, we even helps you to understand viewers demand on your competitor's videos
                  </p>
                  <button className="poster-button" 
                  onClick={()=>{
                    window.scrollTo(0, 0);
                    navigate('/featuresecond');
                    }}>View Features</button>
                </div>
                
             </div>
             </div>
             </div>
              
            

            <div className="end" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
              <h5
                style={{ color: '#fff', cursor: 'pointer', margin: 0 }}
                onClick={() => {
                  window.scrollTo(0, 0); // Scroll to the top
                  navigate('/featuresecond');
                }}
              >
                Next Page
              </h5>
              <button
                className="back-button"
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                  fontSize: '1.2rem',
                }}
                onClick={() => {
                  window.scrollTo(0, 0); // Scroll to the top
                  navigate('/featuresecond');
                }}
              >
                &#x227B;
              </button>
            </div>

            <div className="footer">
            <p>
              &copy; 2025 CommentInsight. All rights reserved. 
            </p>
             </div>
        </div>
    );
    };

export default Footer;